/**
 * People & Companies Module - Utility Functions
 */

/**
 * Get initials from a full name
 */
export function getInitials(name: string): string {
  if (!name) return '?';
  return name
    .split(' ')
    .map(n => n[0])
    .filter(Boolean)
    .slice(0, 2)
    .join('')
    .toUpperCase();
}

/**
 * Format date for display
 */
export function formatDate(dateString: string | undefined | null): string {
  if (!dateString) return '';
  return new Date(dateString).toLocaleDateString();
}

/**
 * Format datetime for display
 */
export function formatDateTime(dateString: string | undefined | null): string {
  if (!dateString) return '';
  return new Date(dateString).toLocaleString();
}

/**
 * Truncate text with ellipsis
 */
export function truncateText(text: string, maxLength: number): string {
  if (text.length <= maxLength) return text;
  return text.slice(0, maxLength).trim() + '...';
}

/**
 * Get importance badge CSS classes
 */
export function getImportanceBadge(importance: string): string {
  const colors: Record<string, string> = {
    vip: 'bg-purple-100 text-purple-800',
    high: 'bg-red-100 text-red-800',
    normal: 'bg-gray-100 text-gray-800',
    low: 'bg-blue-100 text-blue-800',
  };
  return `px-2 py-0.5 text-xs font-medium rounded-full ${colors[importance] || colors.normal}`;
}

/**
 * Format relative date for email threads
 */
export function formatRelativeDate(dateStr: string): string {
  const date = new Date(dateStr);
  const now = new Date();
  const diffDays = Math.floor((now.getTime() - date.getTime()) / (1000 * 60 * 60 * 24));

  if (diffDays === 0) return 'Today';
  if (diffDays === 1) return 'Yesterday';
  if (diffDays < 7) return date.toLocaleDateString('en-US', { weekday: 'short' });
  return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
}
